import { useContext } from 'react';
import { FiltersContext, FiltersContextData } from '../context/filters';

function useDashboardFilters() {
  const context = useContext<FiltersContextData>(FiltersContext);

  return context;
}

export default useDashboardFilters;
